export class CreateInfectedExcludePathInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerResourceId",
            "baseName": "providerResourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "SecurityScanExclusionPathType",
            "format": ""
        },
        {
            "name": "detector",
            "baseName": "detector",
            "type": "DetectorType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateInfectedExcludePathInput.attributeTypeMap;
    }
    constructor() {
    }
}
